import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import styles from './loading-screen.module.css';

export class EntityFormLoadingScreen extends React.Component<Record<any, any>> {
    render() {
        return (
            <div className={styles.container}>
                <div className={styles.bars}>
                    <LoadingIcon size={35} />
                </div>
                <div className={styles.text}>Loading</div>
            </div>
        );
    }
}
